'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { VisuallyHidden } from '../visually-hidden/visually-hidden';
import { gleamDotRecipe } from './styles/gleam-dot.styles';
import type { GleamDotPropsInterface } from './types/gleam-dot.types';

/**
 * @since 10.0.0
 */

export const GleamDot = forwardRef<HTMLSpanElement, GleamDotPropsInterface>(
  (props: GleamDotPropsInterface, forwardedRef) => {
    const {
      tone = 'default',
      onImpact = false,
      count,
      label = 'notifications',
      announce = true,
      className,
      css: cssProp,
    } = props;
    const announcement = label ? `${count} ${label}` : count;

    return (
      <span
        className={cx(
          'c11n',
          'c11n_gleam__dot',
          css(gleamDotRecipe.raw({ tone, onImpact }), cssProp),
          className,
        )}
        data-c11n-component="Gleam.Dot"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
      >
        {announce ? <VisuallyHidden>{announcement}</VisuallyHidden> : null}
      </span>
    );
  },
);

GleamDot.displayName = 'Gleam.Dot';
